exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2b4Oeoqld2d2vLm_Rfc92p{width:100%;height:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}", ""]);
// Exports
exports.locals = {
	"moduleSurface": "_2b4Oeoqld2d2vLm_Rfc92p"
};